import React, { useEffect, useState } from 'react';
import "./ProductDetail.css";
import { Link, useLocation, useParams } from 'react-router-dom';
import CategoriesData from '../Products/CategoriesData';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, } from 'swiper/modules';
import { } from "react-icons/ci";

import 'swiper/css';
import 'swiper/css/navigation';
import ProductHighlight from './ProductHighlight';
import { BiFontSize } from 'react-icons/bi';

const ProductDetail = (props) => {
  /* global dataLayer */
  const location = useLocation();

  useEffect(() => {
    document.title = props.title;

    const canonicalUrl = `${window.location.origin}${location.pathname}`;
    let canonicalLink = document.querySelector("link[rel='canonical']");
    if (canonicalLink) {
      canonicalLink.setAttribute("href", canonicalUrl);
    } else {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", canonicalUrl);
      document.head.appendChild(canonicalLink);
    }

    const description = props.descriptions;
    let metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute("content", description);
    } else {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      metaDescription.setAttribute("content", description);
      document.head.appendChild(metaDescription);
    }
  }, [props.title, props.descriptions, location.pathname]);

  const { pathName } = useParams();

  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await CategoriesData;
        const data = response;
        const subcategories = data.reduce((acc, category) => acc.concat(category.subcategories), []);
        const products = subcategories.reduce((acc, category) => acc.concat(category.Products), []);
        setApiData(products);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const formatPathname = (pathName) => {
    return pathName.toLowerCase().replace(/\s+/g, '-');
  };

  const product = apiData?.find(sub => formatPathname(sub.title) === pathName);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  };

  const extractVideoId = (link) => {
    try {
      const url = new URL(link);
      const id = url.searchParams.get("v");
      if (id) return id;
      if (url.hostname === "youtu.be") return url.pathname.slice(1);
      if (link.includes("embed/")) return link.split("embed/")[1]?.split("?")[0];
    } catch {
      return "";
    }
    return "";
  };


  return (
    <div className='ProductDetail'>
      {loading ? (
        <div className="loader">
          <div className="spinner-grow" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        product && (
          <>
            <ProductHighlight data={product} />
            <div className='ProductDetail-main'>
              <div className='ProductDetail-card'>
                <div className='ProductDetail-box'>
                  <div className='ProductDetail-left'>
                    <img src={product.cover} alt={product.title} />
                  </div>
                  <div className='ProductDetail-right'>

                    <h2>{product.title}</h2>

                    <p>{product.title04}</p>
                    <h3>{product.title2}</h3>
                    <h4>{product.titleb}</h4>

                    <h6>{product.title2A}</h6>
                    <h5>{product.title05}</h5>
                    <h4>{product.title0}</h4>
                    <h6>{product.title01}</h6>
                    <h3>{product.title2C}</h3>
                    <p>{product.description}</p>
                    <h4>{product.headingntms}</h4>
                    <ul>
                      {product.bulletPointsntms && product.bulletPointsntms.map((point, index) => {
                        const [boldPart, ...rest] = point.split(':');
                        return (
                          <li key={index}>
                            <li> <strong>{boldPart} :</strong>{rest.join(':')}</li>

                          </li>
                        );
                      })}
                    </ul>
                    <strong>{product.Headingp}</strong>
                    <p>{product.pragraphp}</p>

                    <ul>
                      {product.bulletPointsA && product.bulletPointsA.map((point, index) => {
                        const [boldPart, ...rest] = point.split(':');
                        return (
                          <li key={index}>
                            <h6>                            {boldPart}{rest.join(':')}</h6>

                          </li>
                        );
                      })}
                    </ul>
                    <ul>
                      {product.bulletPoints208 && product.bulletPoints208.map((point, index) => {
                        const [boldPart, ...rest] = point.split(':');
                        return (
                          <li key={index}>
                            {boldPart}{rest.join(':')}
                          </li>
                        );
                      })}
                    </ul>

                    <h4> <strong>{product.subtitles64s}</strong></h4>

                    <ul>
                      {product.bulletPoints64s && product.bulletPoints64s.map((point, index) => {
                        const [boldPart, ...rest] = point.split(':');
                        return (
                          <li key={index}>
                            <li><strong>{boldPart} :</strong> {rest.join(':')}</li>
                          </li>
                        );
                      })}
                    </ul>

                    <h5>{product.subtitle21}</h5>


                    <h5>{product.subtitle021}</h5>




                    <h5>{product.subtitle31}</h5>
                    <p>{product.description2}</p>


                    <p>{product.description3}</p>

                    <h5>{product.subtitle41}</h5>

                    <p>{product.description4}</p>


                    <h5>{product.subtitle5}</h5>
                    <p>{product.description5}</p>


                  </div>

                </div>


                <div className="productDetail-details">
                  <h3>{product.title201}</h3>
                  <h3>{product.title207}</h3>
                  <p>{product.description201s}</p>
                  <strong>{product.heading1}</strong>
                  <p>{product.pragraph1}</p>
                  <strong>{product.heading2}</strong>
                  <p>{product.pragraph2}</p>
                  <strong>{product.heading3}</strong>
                  <p>{product.pragraph3}</p>
                  <h5>{product.headingb}</h5>
                  <p>{product.pragraphb1}</p>

                  <ul>
                    {product.bulletPointsb && product.bulletPointsb.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>

                  <h5> <strong>{product.stpragra3}</strong></h5>

                  <ul>
                    {product.stpragras3 && product.stpragras3.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li>{boldPart}{rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>

                  <h6> <strong>{product.stpragra4}</strong></h6>

                  <ul>
                    {product.stpragras4 && product.stpragras4.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li><strong>{boldPart} :</strong> {rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>


                  <h7> <strong>{product.stpragra5}</strong></h7>

                  <ul>
                    {product.stpragras5 && product.stpragras5.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li>{boldPart} : {rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>




                  <h5>{product.stpragraph}</h5>
                  <p>{product.stpragh}</p>
                  <p>{product.stpragh3}</p>
                  <p>{product.stpragh4}</p>


                  <p>{product.pragraphb2}</p>
                  <h5>{product.headingb2}</h5>
                  <p>{product.pragraphb3}</p>
                  <h4>{product.stpragrarss}</h4>
                  <h5>{product.headingb3}</h5>
                  <p>{product.pragraphb4}</p>


                  <h5> {product.stpragrar}</h5>
                  <ul>
                    {product.stpragrars3 && product.stpragrars3.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li><strong>{boldPart} :</strong> {rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>


                  <h5> {product.stpragrar4}</h5>
                  <ul>
                    {product.stpragrars4 && product.stpragrars4.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li><strong>{boldPart} :</strong> {rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>

                  <h4> <strong>{product.headingb4}</strong></h4>

                  <ul>
                    {product.bulletPointsb1 && product.bulletPointsb1.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li><strong>{boldPart} :</strong> {rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>

                  <h6> <strong>{product.stpragraph1}</strong></h6>

                  <ul>
                    {product.stpragh2 && product.stpragh2.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li>{boldPart} {rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>



                  <h5>{product.headingb5}</h5>
                  <h5>{product.headingb6}</h5>
                  <p>{product.pragraphb5}</p>
                  <h5>{product.headingb7}</h5>
                  <p>{product.pragraphb7}</p>

                  <h5>{product.headingb8}</h5>
                  <p>{product.pragraphb8}</p>


                  <h4> <strong>{product.headingb9}</strong></h4>

                  <ul>
                    {product.bulletPointsb2 && product.bulletPointsb2.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li><strong>{boldPart} :</strong> {rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>

                  <h5>{product.headingb10}</h5>
                  <p>{product.pragraphb10}</p>
                  <h5>{product.headingb11}</h5>
                  <p>{product.pragraphb11}</p>

                  <h5>{product.headingb12}</h5>
                  <p>{product.pragraphb12}</p>
                  <h5>{product.headingb13}</h5>
                  <p>{product.pragraphb13}</p>




                  <strong>{product.subtitle17p1}</strong>
                  <ul>
                    {product.bulletPoints17p1 && product.bulletPoints17p1.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>



                  <ul>
                    {product.bulletPoints32stv && product.bulletPoints32stv.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li>{boldPart}{rest.join(':')}</li>

                        </li>
                      );
                    })}
                  </ul>

                  <h4><strong>{product.subtitle32svts}</strong></h4>
                  <ul>
                    {product.bulletPoints32stvs && product.bulletPoints32stvs.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <strong>{boldPart}</strong>:{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>


                  <strong>{product.subtitle17p2}</strong>
                  <ul>
                    {product.bulletPoints17p2 && product.bulletPoints17p2.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>

                  <strong>{product.subtitle17p3}</strong>
                  <ul>
                    {product.bulletPoints17p3 && product.bulletPoints17p3.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>
                  <h4> <strong>{product.subtitle64svts}</strong></h4>

                  <ul>
                    {product.bulletPoints64stvs && product.bulletPoints64stvs.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li><strong>{boldPart} :</strong> {rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>

                  <h4> <strong>{product.subtitle84features}</strong></h4>
                  <ul>
                    {product.bulletPoints84features && product.bulletPoints84features.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li><strong>{boldPart} :</strong> {rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>
                  <h4> <strong>{product.subtitle84applicationAreas}</strong></h4>

                  <ul>
                    {product.bulletPoints84applicationAreas && product.bulletPoints84applicationAreas.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <strong>{boldPart} {rest.join(':')}</strong>
                        </li>
                      );
                    })}
                  </ul>

                  {product.bulletPoints0sj && product.bulletPoints0sj.map((item, index) => (
                    <div key={index}>
                      <strong>{item.title}</strong>
                      <ul>
                        {item.points.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  ))}


                  <h5>{product.subtitle0s}</h5>
                  <ul>
                    {product.bulletPoints0s && product.bulletPoints0s.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>
                  <strong>{product.Headingp1}</strong>
                  <p>{product.pragraphp1}</p>
                  <strong>{product.Headingp2}</strong>
                  <p>{product.pragraphp2}</p>
                  <strong>{product.Headingp3}</strong>
                  <p>{product.pragraphp3}</p>
                  {/* <strong>{product.Headingp}</strong>
                  <p>{product.pragraphp1}</p> */}
                  <p>{product.description201}</p>
                  <p>{product.description202}</p>
                  <h3>{product.title203}</h3>
                  <p>{product.description203}</p>
                  <p>{product.description204}</p>
                  <h6>{product.title2m}</h6>
                  <p>{product.description21}</p>
                  <p>{product.description22}</p>
                  <h5>{product.subtitle17p}</h5>

                  <ul>
                    {product.bulletPoints17p && product.bulletPoints17p.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>
                  <h5>{product.subtitle201}</h5>

                  <ul>
                    {product.bulletPoints201 && product.bulletPoints201.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>

                  <h4> <strong>{product.headingn1}</strong></h4>

                  <ul>
                    {product.bulletPointsn1 && product.bulletPointsn1.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li><strong>{boldPart} :</strong> {rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>





                  <h6> <strong>{product.headingn2pe}</strong></h6>

                  <ul>
                    {product.bulletPointsn2pe && product.bulletPointsn2pe.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li><strong>{boldPart} :</strong> {rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>
                  <h6> <strong>{product.headingn2p}</strong></h6>

                  <ul>
                    {product.bulletPointsn2p && product.bulletPointsn2p.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li>{boldPart}{rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>

                  <h5> <strong>{product.headingn2tms}</strong></h5>

                  <ul>
                    {product.bulletPointsn2tms && product.bulletPointsn2tms.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li>{boldPart} {rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>
                  <ul>
                    {product.bulletPointsn2tmss && product.bulletPointsn2tmss.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li><strong>{boldPart}</strong>{rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>
                  <h5> <strong>{product.headingAct}</strong></h5>

                  <ul>
                    {product.bulletPointsAct && product.bulletPointsAct.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li>{boldPart} {rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>

                  <h5>{product.pragHeadingact}</h5>
                  <p>{product.pragraphAct}</p>
                  <h5> <strong>{product.headingAct1}</strong></h5>

                  <ul>
                    {product.bulletPointsAct1 && product.bulletPointsAct1.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <div key={index} >
                          <>{boldPart} {rest.join(':')}</>
                        </div>
                      );
                    })}
                  </ul>
                  <p>{product.pragraph1tms}</p>
                  <h4> <strong>{product.headingn2}</strong></h4>

                  <ul>
                    {product.bulletPointsn2 && product.bulletPointsn2.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li><strong>{boldPart} :</strong> {rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>



                  <h6><strong>{product.headingn3}</strong></h6>
                  <p>{product.pragraphn3}</p>

                  <h6><strong>{product.Headingplb1}</strong></h6>

                  <p>{product.pragraphplb1}</p>
                  <h6><strong>{product.Headingplb2}</strong></h6>

                  <p>{product.pragraphplb2}</p>
                  <h6><strong>{product.Headingplb3}</strong></h6>

                  <p>{product.pragraphplb3}</p>
                  <h6><strong>{product.Headingplb4}</strong></h6>

                  <p>{product.pragraphplb4}</p>



                  <h6><strong>{product.headingbuletslb}</strong></h6>

                  <ul>
                    {product.bulletPoints0spunchlb && product.bulletPoints0spunchlb.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}

                        </li>

                      );
                    })}

                  </ul>
                  <h6><strong>{product.Headingheap}</strong></h6>
                  <h6><strong>{product.Headingheap1}</strong></h6>
                  <p>{product.Heappragraph}</p>

                  <h6><strong>{product.Headingheap2}</strong></h6>
                  <p>{product.Heappragraph1}</p>
                  <h6><strong>{product.Headingheap3}</strong></h6>
                  <p>{product.Heappragraph2}</p>
                  <h6><strong>{product.Headingheap4}</strong></h6>
                  <p>{product.Heappragraph3}</p>


                  <h6> <strong>{product.headingbuletslheap01}</strong></h6>
                  <ul>
                    {product.bulletPoints0spunchlheap && product.bulletPoints0spunchlheap.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li><strong>{boldPart} :</strong> {rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>

                  <h6> <strong>{product.headingbuletslheap1}</strong></h6>
                  <ul>
                    {product.bulletPoints0spunchlheap1 && product.bulletPoints0spunchlheap1.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li><strong>{boldPart} :</strong> {rest.join(':')}</li>
                        </li>
                      );
                    })}
                  </ul>


                  <h6><strong>{product.Headingheap5}</strong></h6>
                  <p>{product.Heappragraph4}</p>




                  <h5>{product.subtitle2}</h5>


                  {/* Bullet points with bold start */}
                  <ul>
                    {product.bulletPoints2 && product.bulletPoints2.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}

                        </li>

                      );
                    })}

                  </ul>
                  <h5>{product.subtitle182}</h5>

                  <h6>{product.subtitle2m}</h6>
                  <ul>
                    {product.bulletPointsm && product.bulletPointsm.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}

                        </li>

                      );
                    })}

                  </ul>

                  <h5>{product.subtitle182t}</h5>
                  <ul>
                    {product.bulletPoints182t && product.bulletPoints182t.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}

                        </li>

                      );
                    })}

                  </ul>
                  <h6>{product.subtitle3m}</h6>
                  <ul>
                    {product.bulletPoints1m && product.bulletPoints1m.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}

                        </li>

                      );
                    })}

                  </ul>

                  <ul>
                    {product.bulletPoints182 && product.bulletPoints182.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (

                        <li key={index}>
                          <strong>{boldPart}</strong>{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>
                  <h6><strong>{product.subtitle1802}</strong></h6>

                  <ul>
                    {product.bulletPoints1802 && product.bulletPoints1802.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (

                        <li key={index}>
                          <li>{boldPart}</li>{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>
                  <h6><strong>{product.subtitle1803}</strong></h6>
                  <ul>
                    {product.bulletPoints1803 && product.bulletPoints1803.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (

                        <li key={index}>
                          <strong>{boldPart}</strong>{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>
                  <h5>{product.subtitle172}</h5>

                  <ul>
                    {product.bulletPoints172 && product.bulletPoints172.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (

                        <li key={index}>
                          <>{boldPart}</>{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>





                  <h5>{product.subtitle193}</h5>

                  <ul>
                    {product.bulletPoints193 && product.bulletPoints193.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (

                        <li key={index}>
                          <>{boldPart}</>{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>
                  <h5>{product.subtitle194}</h5>

                  <ul>
                    {product.bulletPoints194 && product.bulletPoints194.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (

                        <li key={index}>
                          <strong>{boldPart}</strong>{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>











                  <h4>{product.title3}</h4>
                  <p>{product.description31}</p>
                  <p>{product.description32}</p>
                  <h5>{product.subtitle3}</h5>
                  {/* Bullet points with bold start */}
                  <ul>
                    {product.bulletPoints3 && product.bulletPoints3.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>



                  <h4>{product.title4}</h4>
                  <p>{product.description41}</p>
                  <p>{product.description42}</p>
                  <h5><a href='https://www.youtube.com/watch?v=vJpjEqXyec0&list=PLayfN54QgJo0nJxVEtkrEItdRvcRou61I&index=3' style={{ color: "black", textDecoration: "none" }}>{product.subtitle4}</a></h5>
                  <ul>
                    {product.bulletPoints4 && product.bulletPoints4.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>
<h4>{product.subtitle5px}</h4>

                  <h4>{product.title5}</h4>
                  <p>{product.description51}</p>
                  <p>{product.description52}</p>
                  <h5>{product.subtitle05}</h5>
                  <ul>
                    {product.bulletPoints05 && product.bulletPoints05.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>
                  <h5>{product.subtitle03}</h5>
                  <ul>
                    {product.bulletPoints03 && product.bulletPoints03.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>


                  <h4>{product.title6}</h4>
                  <p>{product.description61}</p>
                  <p>{product.description62}</p>
                  <h5>{product.subtitle6}</h5>
                  <ul>
                    {product.bulletPoints6 && product.bulletPoints6.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>




                  <h4>{product.title7}</h4>
                  <p>{product.description71}</p>
                  <p>{product.description72}</p>
                  <h5>{product.subtitle7}</h5>
                  <ul>
                    {product.bulletPoints7 && product.bulletPoints7.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>


                  <h4>{product.title8}</h4>
                  <p>{product.description81}</p>
                  <p>{product.description82}</p>
                  <h5>{product.subtitle8}</h5>


                  <h4>{product.title9}</h4>
                  <p>{product.description85}</p>
                  <p>{product.description86}</p>
                  <h5>{product.subtitle8}</h5>
                  <ul>
                    {product.bulletPoints8 && product.bulletPoints8.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>


                  <ul>
                    {product.bulletPoints11 && product.bulletPoints11.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <strong>{boldPart}</strong>{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>

                  <h5>{product.subtitle102}</h5>
                  <ul>
                    {product.bulletPoints12 && product.bulletPoints12.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <strong>{boldPart}</strong>{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>
                  {/* <p>{product.description2}</p> */}
                  <h5>{product.title03}</h5>
                  <p>{product.description3}</p>
                  <ul>
                    {product.bulletPoints102 && product.bulletPoints102.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <strong>{boldPart}</strong>{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>

                  <h5>{product.subtitle210}</h5>

                  <ul>
                    {product.bulletPoints210 && product.bulletPoints210.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>
                  <h5>{product.subtitle0m}</h5>

                  <ul>
                    {product.bulletPoints0m && product.bulletPoints0m.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>

                  <h5><strong>{product.headingbulets1}</strong></h5>
                  <ol>
                    {product.bulletPoints0spunch1 && product.bulletPoints0spunch1.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <strong> {boldPart} :</strong> {rest.join(':')}
                        </li>
                      );
                    })}
                  </ol>
                  <h5><strong>{product.headingbulets2}</strong></h5>
                  <ul>
                    {product.bulletPoints0spunch2 && product.bulletPoints0spunch2.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <strong> {boldPart} :</strong> {rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>

                  <div>
                    {product.bulletPoints0smm && product.bulletPoints0smm.map((item, index) => (
                      <div key={index}>
                        <strong>{item.title}</strong>
                        <ul>
                          {item.points.map((point, i) => (
                            <li key={i}>{point}</li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                  <div>
                    {product.bulletPoints0ship && product.bulletPoints0ship.map((item, index) => (
                      <div key={index}>
                        <strong>{item.title}</strong>
                        <ul>
                          {item.points.map((point, i) => (
                            <li key={i}>{point}</li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                  <div>
                    {product.bulletPoints0smp && product.bulletPoints0smp.map((item, index) => (
                      <div key={index}>
                        <strong>{item.title}</strong>
                        <ul>
                          {item.points.map((point, i) => (
                            <li key={i}>{point}</li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>

                  {product.bulletPoints0smu && product.bulletPoints0smu.map((item, index) => (
                    <div key={index}>
                      <strong>{item.title}</strong>
                      <ul>
                        {item.points.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                  <h5>{product.subtitle0f}</h5>

                  <ul>
                    {product.bulletPoints0f && product.bulletPoints0f.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <li> {boldPart}{rest.join(':')}</li>

                        </li>
                      );
                    })}
                    {/* <button>click</button> */}
                  </ul>

                  <h5>{product.subtitle209}</h5>
                  <ul>
                    {product.bulletPoints209 && product.bulletPoints209.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          {boldPart}{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>


                  {product.bulletPoints0sms && product.bulletPoints0sms.map((item, index) => (
                    <div key={index}>
                      <strong>{item.title}</strong>
                      <ul>
                        {item.points.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  ))}

                  {product.bulletPoints0smh && product.bulletPoints0smh.map((item, index) => (
                    <div key={index}>
                      <strong>{item.title}</strong>
                      <ul>
                        {item.points.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  ))}

                  {product.bulletPoints0smj && product.bulletPoints0smj.map((item, index) => (
                    <div key={index}>
                      <strong>{item.title}</strong>
                      <ul>
                        {item.points.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  ))}

                  {product.bulletPoints0sme && product.bulletPoints0sme.map((section, index) => (
                    <div key={index} style={{ marginBottom: '1.5rem' }}>

                      {section.title && <h6>{section.title}</h6>}
                      {section.description && (
                        <p >{section.description}</p>
                      )}



                      {section.paragraph && <p>{section.paragraph}</p>}
                      {section.bullet && <p>{section.bullet}</p>}



                      {section.points && (
                        <ul>
                          {section.points.map((point, i) => (
                            <li key={i}>{point}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}


                  <ul>
                    {product.bulletPoints13 && product.bulletPoints13.map((point, index) => {
                      const [boldPart, ...rest] = point.split(':');
                      return (
                        <li key={index}>
                          <strong>{boldPart}</strong>{rest.join(':')}
                        </li>
                      );
                    })}
                  </ul>



                  <div style={{ padding: '20px', fontFamily: 'Segoe UI, sans-serif' }}>

                    {/* Sections */}
                    {product?.sections?.map((section, index) => (
                      <p key={index}>
                        <strong>{section.heading}</strong>, {section.text}
                      </p>
                    ))}

                    {/* Engine Lite */}
                    <h2>{product?.engines?.lite?.title}</h2>
                    <p><strong>{product?.engines?.lite?.intro}</strong></p>
                    <p >
                      {product?.engines?.lite?.details}
                    </p>

                    {/* Engine Extended and Unlimited */}
                    {['extended', 'unlimited'].map((key) => (
                      <div key={key}>
                        <h3>{product?.engines?.[key]?.title}</h3>
                        <p>{product?.engines?.[key]?.description}</p>
                      </div>
                    ))}

                    {/* Application Area */}
                    <h2>{product?.applicationArea?.heading}</h2>
                    <ul>
                      {product?.applicationArea?.items?.map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                    </ul>


                    <div
                      style={{
                        flexWrap: 'wrap',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'stretch',
                        rowGap: '0px',
                        columnGap: '0px',
                      }}
                    >
                      {/* Video Section - Show only if videoLinks1 is available */}
                      {Array.isArray(product.videoLinks1) && product.videoLinks1.length > 0 && (
                        <div
                          style={{
                            flex: '2 1 600px',
                            minWidth: '300px',
                            maxWidth: '100%',
                            padding: '20px',
                            borderRadius: '12px',
                            backgroundColor: '#fff',
                            boxSizing: 'border-box',
                          }}
                        >
                          {product.videoLinks1.map((link, index) => {
                            const videoId = extractVideoId(link);
                            if (!videoId) return null;
                            const embedLink = `https://www.youtube.com/embed/${videoId}`;

                            return (
                              <div
                                key={index}
                                style={{
                                  position: 'relative',
                                  paddingBottom: '56.25%',
                                  height: 0,
                                  overflow: 'hidden',
                                  borderRadius: '10px',
                                  marginBottom: index !== product.videoLinks1.length - 1 ? '16px' : '0',
                                }}
                              >
                                <iframe
                                  src={embedLink}
                                  title={`Video ${index + 1}`}
                                  frameBorder="0"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                  allowFullScreen
                                  style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    border: 'none',
                                  }}
                                ></iframe>
                              </div>
                            );
                          })}
                        </div>
                      )}

                      {/* Button Section - Show only if companyLink1 exists and is non-empty */}
                      {product.companyLink1 && product.companyLink1.trim() !== '' && (
                        <div
                          style={{
                            flex: '1 1 280px',
                            maxWidth: '300px',
                            minWidth: '250px',
                            padding: '20px',
                            borderRadius: '12px',
                            backgroundColor: '#fff',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            boxSizing: 'border-box',
                            marginBottom: '23px',
                          }}
                        >
                          <a
                            href={product.companyLink1}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              pointerEvents: 'auto',
                              textDecoration: 'none',
                              width: '100%',
                            }}
                          >
                            <button
                              style={{
                                width: '100%',
                                height: '60px',
                                fontSize: '17px',
                                backgroundColor: '#f0800f',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '10px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s',
                              }}
                              onMouseOver={(e) => {
                                e.target.style.backgroundColor = '#f0800f';
                              }}
                              onMouseOut={(e) => {
                                e.target.style.backgroundColor = '#f0800f';
                              }}
                            >
                              {product.buttons1}
                            </button>
                          </a>
                        </div>
                      )}
                    </div>



                  </div>
                  <div style={{ padding: '20px', fontFamily: 'Segoe UI, sans-serif' }}>

                    {/* Sections */}
                    {product?.sections?.map((section, index) => (
                      <p key={index}>
                        <strong>{section.heading}</strong>, {section.text}
                      </p>
                    ))}

                    {/* Engine Lite */}
                    <h2>{product?.engines?.lite?.title}</h2>
                    <p><strong>{product?.engines?.lite?.intro}</strong></p>
                    <p >
                      {product?.engines?.lite?.details}
                    </p>

                    {/* Engine Extended and Unlimited */}
                    {['extended', 'unlimited'].map((key) => (
                      <div key={key}>
                        <h3>{product?.engines?.[key]?.title}</h3>
                        <p>{product?.engines?.[key]?.description}</p>
                      </div>
                    ))}

                    {/* Application Area */}
                    <h2>{product?.applicationArea?.heading}</h2>
                    <ul>
                      {product?.applicationArea?.items?.map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                    </ul>



                  </div>

                </div>


              </div>
            </div>
          </>
        )
      )}


    </div>
  );
};

export default ProductDetail;
